// Abertura do app sem internet (revisão das lojas): em vez de ~20 s de splash com "Reconectando…" e depois "Não deu
// para verificar sua sessão", a tela diz em até 5 s "Sem internet. Conecte-se para entrar." com "Tentar de novo".
// Decisão pura (guardas.tsx usa com o estado da consulta da sessão), testada em semInternet.test.ts.
import { ehErroApi } from "./api/cliente";

/** Prazo máximo, desde a abertura, para trocar o splash pela tela "Sem internet" quando a rede falha. */
export const LIMITE_SEM_INTERNET_MS = 5_000;

export interface EstadoAberturaSessao {
  /** A sessão já chegou (logado ou não: `null` também é resposta). */
  temResposta: boolean;
  /** A consulta terminou em erro (depois das repetições). */
  falhou: boolean;
  /** Erro final ou o da última tentativa que falhou (`failureReason`). */
  erro: unknown;
  /** `navigator.onLine`. Falso = o aparelho sabe que está sem rede (o TanStack nem tenta: fica em pausa). */
  online: boolean;
  /** Já passou `LIMITE_SEM_INTERNET_MS` desde que a consulta começou. */
  passouLimite: boolean;
}

/**
 * Mostrar "Sem internet"? Só para falha de REDE (SEM_CONEXAO). API fora do ar no deploy (502/503) continua com o
 * splash e o "Reconectando…" de sempre, e outros erros com "Não deu para verificar sua sessão".
 */
export function deveMostrarSemInternet(e: EstadoAberturaSessao): boolean {
  if (e.temResposta) return false;
  const deRede = ehErroApi(e.erro, "SEM_CONEXAO");
  if (e.falhou) return deRede || !e.online;
  return !e.online || (deRede && e.passouLimite);
}
